import React from "react";
import graph from "./graph";
import Dropzone from "react-dropzone-uploader";
import BackupRoundedIcon from "@mui/icons-material/BackupRounded";
import DeleteOutlineRounded from "@mui/icons-material/DeleteOutlineRounded";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";
import { getDroppedOrSelectedFiles } from "html5-file-selector";
import {
  Box,
  Card,
  Stack,
  Button,
  CardMedia,
  IconButton,
  Typography,
  CircularProgress,
} from "@mui/material";

export default function Uploader(props) {
  if (props.media) return <Media {...props} />;
  return <Content {...props} />;
}

function Media({ id, model, media, refetch }) {
  const { userToken } = useSelector((state) => state.auth);

  const [handleDelete, { loading }] = useMutation(graph.unassign.query, {
    context: {
      serviceName: graph.unassign.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onDelete = async () => {
    try {
      const { data, errors } = await handleDelete({
        variables: { id, media_ids: media?.id, model_name: model },
      });
      if (!errors) {
        if (!isEmptyObject(data)) {
          refetch();
          // data[graph.unassign.name]?.messages.map((message) =>
          //   toast.success(String(message))
          // );
        }
      }
    } catch (error) {}
  };

  return (
    <Card sx={{ width: "100%", borderRadius: 2 }}>
      <CardMedia
        image={media?.full_url}
        sx={{ height: 148, position: "relative" }}
      >
        <Stack
          top={0}
          left={0}
          right={0}
          bottom={0}
          position="absolute"
          justifyContent="space-between"
        >
          <Stack p={1} flex={1} alignItems="center"></Stack>
          <Stack
            p={1}
            width="100%"
            direction="row"
            columnGap={0.5}
            alignItems="center"
            justifyContent="space-between"
          >
            <IconButton size="small" color="error" onClick={onDelete}>
              {loading ? (
                <CircularProgress size={25} />
              ) : (
                <DeleteOutlineRounded />
              )}
            </IconButton>
          </Stack>
        </Stack>
      </CardMedia>
    </Card>
  );
}

function Content({
  id,
  model,
  refetch,
  collection,
  maxSize = 10,
  minSize = 1,
  maxFiles = 1,
  label = "انتخاب فایل",
  caption,
}) {
  const { userToken } = useSelector((state) => state.auth);

  const [muatate, { loading }] = useMutation(graph.assign.query, {
    context: {
      serviceName: graph.assign.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  // const [files, setFiles] = useState();

  const onChange = async (files) => {
    try {
      const { data } = await muatate({
        variables: {
          id,
          files,
          model_name: model,
          collection_name: collection,
        },
      });
      if (!isEmptyObject(data)) {
        refetch();
        // const { messages } = data[graph.assign.name];
        // messages.map((message) => toast.success(String(message)));
      }
    } catch (error) {}
  };

  const handleSubmit = (files, allFiles) => {
    // onChange();
    allFiles.forEach((f) => f.remove());
  };

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === "done") {
      return onChange(file);
      // return setFiles(file);
    }
    // if (status === "removed") {
    //   return refetch();
    //   // return onDelete();
    // }
    return;
  };

  const getFilesFromEvent = (e) => {
    return new Promise((resolve) => {
      getDroppedOrSelectedFiles(e).then((chosenFiles) => {
        resolve(chosenFiles.map((f) => f.fileObject));
      });
    });
  };

  return (
    <Dropzone
      multiple={false}
      maxFiles={maxFiles}
      onSubmit={handleSubmit}
      minSizeBytes={minSize * 10}
      maxSizeBytes={maxSize * 1000000}
      onChangeStatus={handleChangeStatus}
      accept="image/*,audio/*,video/*"
      inputContent={(files, extra) =>
        extra.reject ? (
          "Image, audio and video files only"
        ) : (
          <Stack alignItems="center" rowGap={0.5}>
            <Typography variant="subtitle1" color="textSecondary" fontSize={12}>
              {label}
            </Typography>
            {caption && (
              <Typography variant="caption" color="textDisabled">
                ({caption})
              </Typography>
            )}
          </Stack>
        )
      }
      styles={{
        dropzone: { height: "100%" },
        dropzoneReject: { borderColor: "red", backgroundColor: "#DAA" },
        inputLabel: (files, extra) => (extra.reject ? { color: "red" } : {}),
      }}
      inputWithFilesContent={(files) => `${maxFiles - files.length} more`}
      InputComponent={Input}
      LayoutComponent={Layout}
      PreviewComponent={(props) => <Preview {...props} loading={loading} />}
      SubmitButtonComponent={null}
      // SubmitButtonComponent={(props) => (
      //   <SubmitButtonComponent {...props} loading={loading} />
      // )}
      getFilesFromEvent={getFilesFromEvent}
      disabled={(files) =>
        files.some((f) =>
          ["preparing", "getting_upload_params", "uploading"].includes(
            f.meta.status
          )
        )
      }
    />
  );
}

const SubmitButtonComponent = (props) => {
  const { extra, content, disabled, loading, onSubmit } = props;

  return (
    <Button
      fullWidth
      variant="contained"
      onClick={onSubmit}
      disabled={loading || disabled}
    >
      {content}
    </Button>
  );
};

const Preview = ({ meta, fileWithMeta, canRemove, loading }) => {
  const { remove } = fileWithMeta;
  const { name, size, width, height, percent, status, previewUrl } = meta;

  return (
    <Card sx={{ flexGrow: 1, borderRadius: 2 }}>
      {status === "error_file_size" ? (
        <CardMedia sx={{ height: 148, position: "relative" }}>
          <Stack
            top={0}
            left={0}
            right={0}
            bottom={0}
            position="absolute"
            justifyContent="space-between"
          >
            <Stack p={1} flex={1} alignItems="center">
              <Box
                px={0.5}
                py={0.25}
                borderRadius={1}
                color="#ffffff"
                bgcolor="error.main"
              >
                <Typography variant="caption">
                  حجم فایل انتخاب شده بیش از حد مجاز است!
                </Typography>
              </Box>
            </Stack>
            <Stack
              width="100%"
              direction="row"
              columnGap={0.5}
              justifyContent="flex-end"
            >
              {canRemove && (
                <IconButton size="small" color="error" onClick={remove}>
                  <DeleteOutlineRounded />
                </IconButton>
              )}
            </Stack>
          </Stack>
        </CardMedia>
      ) : (
        <CardMedia
          sx={{ height: 148, position: "relative" }}
          image={previewUrl}
        >
          <Stack
            top={0}
            left={0}
            right={0}
            bottom={0}
            position="absolute"
            justifyContent="space-between"
          >
            <Stack p={1} flex={1} alignItems="center">
              <Typography
                fontSize={10}
                variant="caption"
                color="text.disabled"
              >{`${width} * ${height}`}</Typography>
              <Typography fontSize={10} variant="caption" color="text.disabled">
                {`${(size / 1000).toFixed(2)} کیلوبایت`}
              </Typography>
            </Stack>
            <Stack
              p={1}
              width="100%"
              direction="row"
              columnGap={0.5}
              alignItems="center"
              justifyContent="space-between"
            >
              {loading ? (
                <CircularProgress size={22} />
              ) : (
                canRemove && (
                  <IconButton size="small" color="error" onClick={remove}>
                    <DeleteOutlineRounded />
                  </IconButton>
                )
              )}
            </Stack>
          </Stack>
        </CardMedia>
      )}
    </Card>
  );
};

const Layout = ({
  input,
  files,
  previews,
  submitButton,
  dropzoneProps,
  extra: { maxFiles },
}) => {
  return (
    <Stack width="100%" rowGap={1}>
      {previews.length > 0 ? (
        <Stack flex={1}>{previews}</Stack>
      ) : (
        <Box flex={1} {...dropzoneProps}>
          {files.length < maxFiles && input}
        </Box>
      )}
      {files.length > 0 && submitButton}
    </Stack>
  );
};

const Input = (props) => {
  const { content, accept, onFiles, files, getFilesFromEvent } = props;
  const text = files.length > 0 ? "بارگذاری فایل های بیشتر" : content;
  const id = Math.random();
  return (
    <>
      <input
        multiple
        id={id}
        name="file"
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => {
          getFilesFromEvent(e).then((chosenFiles) => {
            onFiles(chosenFiles);
          });
        }}
      />
      <label htmlFor={id}>
        <Card
          sx={{
            borderRadius: 2,
            transition: "all 0.5s ease",
            ":hover": { bgcolor: "#f1f1f1", transition: "all 0.7s ease" },
          }}
        >
          <Stack minHeight={148} alignItems="center" justifyContent="center">
            <Typography color="text.secondary" fontSize={40}>
              <BackupRoundedIcon fontSize="inherit" />
            </Typography>
            <Typography
              fontSize={12}
              variant="subtitle1"
              color="text.secondary"
            >
              {text}
            </Typography>
          </Stack>
        </Card>
      </label>
    </>
  );
};
